<template>
    <BaseModal :title="'Add Custom'" @close="closeModal" :visible="true">
        <form @submit.prevent="onSubmit">
            <div class="rlms-flex rlms-flex-col rlms-gap-30">
                <div class="pp-body-scroll">

                    <div class="rlms-flex rlms-flex-col rlms-gap-15">
                        <div class="rlms-flex rlms-flex-col">
                            <label for="word" class="rlms-fs-xs rlms-fw-500">Target:</label>
                            <input type="text" placeholder="Target" v-model.trim="word" />
                            <span class="rlms-text-danger-500 rlms-fs-xxs error-text" v-if="submitted && wordError">
                                {{ wordError }}
                            </span>
                        </div>
                        <div class="rlms-flex rlms-flex-col">
                            <label for="ipa" class="rlms-fs-xs rlms-fw-500">Phonetic:</label>
                            <input type="text" placeholder="Phonetic" v-model.trim="ipa" />
                            <span class="rlms-text-danger-500 rlms-fs-xxs error-text" v-if="submitted && ipaError">
                                {{ ipaError }}
                            </span>
                        </div>
                        <div class="rlms-flex rlms-flex-col">
                            <label for="consonants" class="rlms-fs-xs rlms-fw-500">Consonants:</label>
                            <input type="text" placeholder="Consonants" v-model.trim="consonants" />
                            <span class="rlms-text-danger-500 rlms-fs-xxs error-text" v-if="submitted && consonantsError">
                                {{ consonantsError }}
                            </span>
                        </div>
                        <div class="rlms-flex rlms-flex-col">
                            <label for="vowels" class="rlms-fs-xs rlms-fw-500">Vowels:</label>
                            <input type="text" placeholder="Vowels" v-model.trim="vowels" />
                            <span class="rlms-text-danger-500 rlms-fs-xxs error-text" v-if="submitted && vowelsError">
                                {{ vowelsError }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <template #footer>
            <div class="pp-footer rlms-flex rlms-justify-between" style="padding: 0;">
                <button class="rlms-btn rlms-btn-outline-primary p-cancel-btn" type="button" id="cancel-org-modal"
                    @click="closeModal">
                    Cancel
                </button>
                <button type="submit" class="rlms-btn rlms-btn-primary" id="save-org-btn" @click="onSubmit">
                    Save
                </button>
            </div>
        </template>
    </BaseModal>
</template>

<script setup>
import { ref } from 'vue';
import { useForm, useField } from 'vee-validate';
import * as yup from 'yup';
import { handleError } from '@/utils/handleError';
import { useLoaderStore } from '@/stores/loader';
import BaseModal from '@/components/BaseModal.vue';
import { showToast } from '@/utils/swal';

const loader = useLoaderStore();
const emit = defineEmits(['close', 'saved']);

const showModal = ref(true);
const submitting = ref(false);
const submitted = ref(false);

const props = defineProps({
    selectedItems: Array,
});

// Close modal
const closeModal = () => {
    showModal.value = false;
    emit('close');
};

// Validation schema
const formSchema = yup.object({
    word: yup.string().required('Required.'),
    ipa: yup.string().required('Required.'),
    consonants: yup.string().required('Required.'),
    vowels: yup.string().required('Required.'),
});

const { handleSubmit, setErrors } = useForm({
    validationSchema: formSchema,
});

// Fields
const { value: word, errorMessage: wordError } = useField('word');
const { value: ipa, errorMessage: ipaError } = useField('ipa');
const { value: consonants, errorMessage: consonantsError } = useField('consonants');
const { value: vowels, errorMessage: vowelsError } = useField('vowels');

// Submit handler
const onSubmit = async () => {
    submitted.value = true;

    await handleSubmit(async (values) => {
        const exists = props.selectedItems?.some(i => i.word === values.word);
        if(exists) {
            submitted.value= false;
            
            showToast({
                icon: 'warning',
                title: 'Warning ',
                text: 'Item Already Exist.',
            });

            return;
        }
        
        submitting.value = true;
        try {
            
            loader.show();

            emit('saved', { ...values });

            closeModal();
        } catch (error) {
            if (error?.response?.status === 422) {
                const serverErrors = error?.response?.data?.errors || {};
                const fieldErrors = {};

                Object.keys(serverErrors).forEach((key) => {
                    fieldErrors[key] = serverErrors[key][0];
                });

                if (Object.keys(fieldErrors).length > 0) {
                    setErrors(fieldErrors);
                } else {
                    handleError(error, true);
                }
            } else {
                handleError(error);
            }
        } finally {
            submitting.value = false;
            loader.hide();
        }
    })();
};
</script>